import { app } from '../../../app';
import { Controller } from './google-hangouts-bot.controller';

app.component('companyGoogleHangoutsBot', {
    bindings: {appType$: '<'},
    controller: Controller,
    templateUrl: require('./google-hangouts-bot.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/google-hangouts-bot/google-hangouts-bot.component.js